import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: null,
  loaded: null,
  error: null,
  data: null,
  status: null,
};

// Slice
const agreePrivacySlice = createSlice({
  name: "agreePrivacy",
  initialState,
  reducers: {
    submitData(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setStatus(state) {
      return {
        ...state,
        status: true,
      };
    },
    initState(state) {
      return {
        ...state,
        loading: null,
        loaded: null,
        error: null,
        data: null,
        status: null,
      };
    },
  },
});

export const {
  submitData,
  fetchDataSuccess,
  fetchDataFailure,
  setStatus,
  initState,
} = agreePrivacySlice.actions;

export default agreePrivacySlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.post, apiUrl, data);
    if (response?.data) {
      const { code } = response.data;
      if (code === "0000") {
        yield put(setStatus());
      }
    }
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* agreePrivacySaga() {
  yield takeLatest(submitData.type, fetchDataSaga);
}
